/**
 * Ordre des sections guide par rôle — strictement ciblé métier (pas de mélange inter-rôles).
 * Chaque section : presentation + procedure (i18n supportGuide.sections.*).
 * FAQ : même schéma sections + accordéon (généré build-faq-by-section-fr.js).
 */
// @faq-mapping-start
export const FAQ_KEYS_BY_SECTION = {
  "ad_dashboard": [
    "ad_dashboard",
    "faq_ad_dashboard_objectif",
    "faq_ad_dashboard_demarrage",
    "faq_ad_dashboard_situation"
  ],
  "ad_formulaire_intervention": [
    "ad_creer_intervention",
    "anti_doublon_intervention",
    "faq_ad_formulaire_intervention_objectif",
    "faq_ad_formulaire_intervention_demarrage",
    "faq_ad_formulaire_intervention_situation",
    "faq_ad_formulaire_intervention_precision"
  ],
  "ad_menu_lateral": [
    "ad_menu_acces",
    "faq_ad_menu_lateral_objectif",
    "faq_ad_menu_lateral_demarrage",
    "faq_ad_menu_lateral_situation",
    "faq_ad_menu_lateral_precision"
  ],
  "ad_messagerie": [
    "messagerie_bulle",
    "ad_pas_moderation",
    "faq_ad_messagerie_objectif",
    "faq_ad_messagerie_demarrage",
    "faq_ad_messagerie_situation"
  ],
  "ad_notifications_cloche": [
    "cloche_centre",
    "faq_ad_notifications_cloche_objectif",
    "faq_ad_notifications_cloche_demarrage",
    "faq_ad_notifications_cloche_situation"
  ],
  "ad_page_clients": [
    "ad_clients",
    "faq_ad_page_clients_objectif",
    "faq_ad_page_clients_demarrage",
    "faq_ad_page_clients_situation"
  ],
  "ad_page_intervenants": [
    "ad_intervenants",
    "ad_intervenant_no_delete",
    "faq_ad_page_intervenants_objectif",
    "faq_ad_page_intervenants_demarrage",
    "faq_ad_page_intervenants_situation"
  ],
  "ad_page_interventions": [
    "ad_no_delete",
    "faq_ad_page_interventions_objectif",
    "faq_ad_page_interventions_demarrage",
    "faq_ad_page_interventions_situation"
  ],
  "ad_page_rapports": [
    "ad_rapports_valid",
    "faq_ad_page_rapports_objectif",
    "faq_ad_page_rapports_demarrage",
    "faq_ad_page_rapports_situation"
  ],
  "ad_parametres": [
    "ad_parametres",
    "faq_ad_parametres_objectif",
    "faq_ad_parametres_demarrage",
    "faq_ad_parametres_situation"
  ],
  "ad_parametres_donnees": [
    "export_donnees",
    "faq_ad_parametres_donnees_objectif",
    "faq_ad_parametres_donnees_demarrage",
    "faq_ad_parametres_donnees_situation"
  ],
  "ad_planning_global": [
    "ad_planning",
    "faq_ad_planning_global_objectif",
    "faq_ad_planning_global_demarrage",
    "faq_ad_planning_global_situation",
    "faq_ad_planning_global_precision"
  ],
  "ad_popup_intervention": [
    "ad_popup_actions",
    "staff_reprogram",
    "faq_ad_popup_intervention_objectif",
    "faq_ad_popup_intervention_demarrage",
    "faq_ad_popup_intervention_situation",
    "faq_ad_popup_intervention_precision"
  ],
  "ad_signalements_emails": [
    "ad_signalement",
    "faq_ad_signalements_emails_objectif",
    "faq_ad_signalements_emails_demarrage",
    "faq_ad_signalements_emails_situation"
  ],
  "ad_ui_avatars_medias": [
    "faq_ad_ui_avatars_medias_objectif",
    "faq_ad_ui_avatars_medias_demarrage",
    "faq_ad_ui_avatars_medias_situation",
    "faq_ad_ui_avatars_medias_precision"
  ],
  "ad_ui_banniere_horloge": [
    "faq_ad_ui_banniere_horloge_objectif",
    "faq_ad_ui_banniere_horloge_demarrage",
    "faq_ad_ui_banniere_horloge_situation",
    "faq_ad_ui_banniere_horloge_precision"
  ],
  "ad_ui_boutons_actions": [
    "faq_ad_ui_boutons_actions_objectif",
    "faq_ad_ui_boutons_actions_demarrage",
    "faq_ad_ui_boutons_actions_situation",
    "faq_ad_ui_boutons_actions_precision"
  ],
  "ad_ui_cartes_listes": [
    "faq_ad_ui_cartes_listes_objectif",
    "faq_ad_ui_cartes_listes_demarrage",
    "faq_ad_ui_cartes_listes_situation",
    "faq_ad_ui_cartes_listes_precision"
  ],
  "ad_ui_cartes_statistiques": [
    "faq_ad_ui_cartes_statistiques_objectif",
    "faq_ad_ui_cartes_statistiques_demarrage",
    "faq_ad_ui_cartes_statistiques_situation",
    "faq_ad_ui_cartes_statistiques_precision"
  ],
  "ad_ui_cartes_statuts": [
    "faq_ad_ui_cartes_statuts_objectif",
    "faq_ad_ui_cartes_statuts_demarrage",
    "faq_ad_ui_cartes_statuts_situation",
    "faq_ad_ui_cartes_statuts_precision"
  ],
  "ad_ui_couleurs_privileges": [
    "faq_ad_ui_couleurs_privileges_objectif",
    "faq_ad_ui_couleurs_privileges_demarrage",
    "faq_ad_ui_couleurs_privileges_situation",
    "faq_ad_ui_couleurs_privileges_precision"
  ],
  "ad_ui_etiquettes_icones": [
    "faq_ad_ui_etiquettes_icones_objectif",
    "faq_ad_ui_etiquettes_icones_demarrage",
    "faq_ad_ui_etiquettes_icones_situation",
    "faq_ad_ui_etiquettes_icones_precision"
  ],
  "ad_ui_fenetres_modales": [
    "faq_ad_ui_fenetres_modales_objectif",
    "faq_ad_ui_fenetres_modales_demarrage",
    "faq_ad_ui_fenetres_modales_situation",
    "faq_ad_ui_fenetres_modales_precision"
  ],
  "ad_ui_filtres_listes": [
    "faq_ad_ui_filtres_listes_objectif",
    "faq_ad_ui_filtres_listes_demarrage",
    "faq_ad_ui_filtres_listes_situation",
    "faq_ad_ui_filtres_listes_precision"
  ],
  "ad_ui_filtres_planning": [
    "faq_ad_ui_filtres_planning_objectif",
    "faq_ad_ui_filtres_planning_demarrage",
    "faq_ad_ui_filtres_planning_situation",
    "faq_ad_ui_filtres_planning_precision"
  ],
  "ad_ui_securite_performance": [
    "faq_ad_ui_securite_performance_objectif",
    "faq_ad_ui_securite_performance_demarrage",
    "faq_ad_ui_securite_performance_situation",
    "faq_ad_ui_securite_performance_precision"
  ],
  "ad_ui_temps_reel": [
    "faq_ad_ui_temps_reel_objectif",
    "faq_ad_ui_temps_reel_demarrage",
    "faq_ad_ui_temps_reel_situation",
    "faq_ad_ui_temps_reel_precision"
  ],
  "appearance": [
    "theme_lang",
    "notifications",
    "mobile",
    "faq_appearance_objectif",
    "faq_appearance_demarrage",
    "faq_appearance_situation",
    "faq_appearance_precision"
  ],
  "cl_dashboard": [
    "faq_cl_dashboard_objectif",
    "faq_cl_dashboard_demarrage",
    "faq_cl_dashboard_situation"
  ],
  "cl_fiche_intervention": [
    "faq_cl_fiche_intervention_objectif",
    "faq_cl_fiche_intervention_demarrage",
    "faq_cl_fiche_intervention_situation"
  ],
  "cl_menu_lateral": [
    "faq_cl_menu_lateral_objectif",
    "faq_cl_menu_lateral_demarrage",
    "faq_cl_menu_lateral_situation",
    "faq_cl_menu_lateral_precision"
  ],
  "cl_messagerie": [
    "cl_messagerie",
    "messagerie_bulle",
    "faq_cl_messagerie_objectif",
    "faq_cl_messagerie_demarrage",
    "faq_cl_messagerie_situation"
  ],
  "cl_notifications_cloche": [
    "cl_cloche",
    "cloche_centre",
    "faq_cl_notifications_cloche_objectif",
    "faq_cl_notifications_cloche_demarrage",
    "faq_cl_notifications_cloche_situation"
  ],
  "cl_page_equipements": [
    "cl_equipements",
    "cl_readonly",
    "faq_cl_page_equipements_objectif",
    "faq_cl_page_equipements_demarrage",
    "faq_cl_page_equipements_situation"
  ],
  "cl_page_interventions": [
    "cl_interventions_liste",
    "cl_statut_intervention",
    "faq_cl_page_interventions_objectif",
    "faq_cl_page_interventions_demarrage",
    "faq_cl_page_interventions_situation"
  ],
  "cl_page_rapports": [
    "cl_reports_pdf",
    "faq_cl_page_rapports_objectif",
    "faq_cl_page_rapports_demarrage",
    "faq_cl_page_rapports_situation"
  ],
  "cl_page_sites": [
    "cl_sites",
    "cl_readonly",
    "faq_cl_page_sites_objectif",
    "faq_cl_page_sites_demarrage",
    "faq_cl_page_sites_situation"
  ],
  "cl_planning_lecture": [
    "cl_planning_lecture",
    "faq_cl_planning_lecture_objectif",
    "faq_cl_planning_lecture_demarrage",
    "faq_cl_planning_lecture_situation"
  ],
  "cl_popup_intervention": [
    "cl_popup_actions",
    "cl_reprogram_once",
    "cl_reprogrammer_conditions",
    "faq_cl_popup_intervention_objectif",
    "faq_cl_popup_intervention_demarrage",
    "faq_cl_popup_intervention_situation",
    "faq_cl_popup_intervention_precision"
  ],
  "cl_profil": [
    "cl_parametres",
    "faq_cl_profil_objectif",
    "faq_cl_profil_demarrage",
    "faq_cl_profil_situation"
  ],
  "cl_profil_donnees": [
    "export_donnees",
    "faq_cl_profil_donnees_objectif",
    "faq_cl_profil_donnees_demarrage",
    "faq_cl_profil_donnees_situation"
  ],
  "cl_signalements_emails": [
    "faq_cl_signalements_emails_objectif",
    "faq_cl_signalements_emails_demarrage",
    "faq_cl_signalements_emails_situation"
  ],
  "cl_ui_avatars_medias": [
    "faq_cl_ui_avatars_medias_objectif",
    "faq_cl_ui_avatars_medias_demarrage",
    "faq_cl_ui_avatars_medias_situation",
    "faq_cl_ui_avatars_medias_precision"
  ],
  "cl_ui_banniere_horloge": [
    "faq_cl_ui_banniere_horloge_objectif",
    "faq_cl_ui_banniere_horloge_demarrage",
    "faq_cl_ui_banniere_horloge_situation",
    "faq_cl_ui_banniere_horloge_precision"
  ],
  "cl_ui_boutons_actions": [
    "faq_cl_ui_boutons_actions_objectif",
    "faq_cl_ui_boutons_actions_demarrage",
    "faq_cl_ui_boutons_actions_situation",
    "faq_cl_ui_boutons_actions_precision"
  ],
  "cl_ui_cartes_listes": [
    "faq_cl_ui_cartes_listes_objectif",
    "faq_cl_ui_cartes_listes_demarrage",
    "faq_cl_ui_cartes_listes_situation",
    "faq_cl_ui_cartes_listes_precision"
  ],
  "cl_ui_cartes_statistiques": [
    "faq_cl_ui_cartes_statistiques_objectif",
    "faq_cl_ui_cartes_statistiques_demarrage",
    "faq_cl_ui_cartes_statistiques_situation",
    "faq_cl_ui_cartes_statistiques_precision"
  ],
  "cl_ui_cartes_statuts": [
    "faq_cl_ui_cartes_statuts_objectif",
    "faq_cl_ui_cartes_statuts_demarrage",
    "faq_cl_ui_cartes_statuts_situation",
    "faq_cl_ui_cartes_statuts_precision"
  ],
  "cl_ui_etiquettes_icones": [
    "faq_cl_ui_etiquettes_icones_objectif",
    "faq_cl_ui_etiquettes_icones_demarrage",
    "faq_cl_ui_etiquettes_icones_situation",
    "faq_cl_ui_etiquettes_icones_precision"
  ],
  "cl_ui_fenetres_modales": [
    "faq_cl_ui_fenetres_modales_objectif",
    "faq_cl_ui_fenetres_modales_demarrage",
    "faq_cl_ui_fenetres_modales_situation",
    "faq_cl_ui_fenetres_modales_precision"
  ],
  "cl_ui_filtres_equipements": [
    "faq_cl_ui_filtres_equipements_objectif",
    "faq_cl_ui_filtres_equipements_demarrage",
    "faq_cl_ui_filtres_equipements_situation",
    "faq_cl_ui_filtres_equipements_precision"
  ],
  "cl_ui_filtres_listes": [
    "faq_cl_ui_filtres_listes_objectif",
    "faq_cl_ui_filtres_listes_demarrage",
    "faq_cl_ui_filtres_listes_situation",
    "faq_cl_ui_filtres_listes_precision"
  ],
  "cl_ui_securite_performance": [
    "faq_cl_ui_securite_performance_objectif",
    "faq_cl_ui_securite_performance_demarrage",
    "faq_cl_ui_securite_performance_situation",
    "faq_cl_ui_securite_performance_precision"
  ],
  "cl_ui_temps_reel": [
    "faq_cl_ui_temps_reel_objectif",
    "faq_cl_ui_temps_reel_demarrage",
    "faq_cl_ui_temps_reel_situation",
    "faq_cl_ui_temps_reel_precision"
  ],
  "guest_public_pages": [
    "guest_pages_publiques",
    "guest_maintenance",
    "faq_guest_public_pages_objectif",
    "faq_guest_public_pages_demarrage",
    "faq_guest_public_pages_situation",
    "faq_guest_public_pages_precision"
  ],
  "guest_ui_connexion": [
    "faq_guest_ui_connexion_objectif",
    "faq_guest_ui_connexion_demarrage",
    "faq_guest_ui_connexion_situation",
    "faq_guest_ui_connexion_precision"
  ],
  "guest_ui_elements_visuels": [
    "faq_guest_ui_elements_visuels_objectif",
    "faq_guest_ui_elements_visuels_demarrage",
    "faq_guest_ui_elements_visuels_situation",
    "faq_guest_ui_elements_visuels_precision"
  ],
  "intro": [
    "roles",
    "faq_intro_objectif",
    "faq_intro_demarrage",
    "faq_intro_situation",
    "faq_intro_precision"
  ],
  "iv_dashboard": [
    "faq_iv_dashboard_objectif",
    "faq_iv_dashboard_demarrage",
    "faq_iv_dashboard_situation"
  ],
  "iv_disponibilites": [
    "iv_disponibilites",
    "faq_iv_disponibilites_objectif",
    "faq_iv_disponibilites_demarrage",
    "faq_iv_disponibilites_situation"
  ],
  "iv_fiche_intervention": [
    "faq_iv_fiche_intervention_objectif",
    "faq_iv_fiche_intervention_demarrage",
    "faq_iv_fiche_intervention_situation"
  ],
  "iv_formulaire_rapport": [
    "iv_rapport_brouillon",
    "iv_rapport_photos",
    "faq_iv_formulaire_rapport_objectif",
    "faq_iv_formulaire_rapport_demarrage",
    "faq_iv_formulaire_rapport_situation",
    "faq_iv_formulaire_rapport_precision"
  ],
  "iv_menu_lateral": [
    "faq_iv_menu_lateral_objectif",
    "faq_iv_menu_lateral_demarrage",
    "faq_iv_menu_lateral_situation"
  ],
  "iv_messagerie": [
    "iv_messagerie",
    "messagerie_bulle",
    "faq_iv_messagerie_objectif",
    "faq_iv_messagerie_demarrage",
    "faq_iv_messagerie_situation"
  ],
  "iv_notifications_cloche": [
    "iv_cloche",
    "cloche_centre",
    "faq_iv_notifications_cloche_objectif",
    "faq_iv_notifications_cloche_demarrage",
    "faq_iv_notifications_cloche_situation"
  ],
  "iv_page_interventions": [
    "iv_liste_interventions",
    "faq_iv_page_interventions_objectif",
    "faq_iv_page_interventions_demarrage",
    "faq_iv_page_interventions_situation"
  ],
  "iv_page_rapports": [
    "iv_report",
    "faq_iv_page_rapports_objectif",
    "faq_iv_page_rapports_demarrage",
    "faq_iv_page_rapports_situation"
  ],
  "iv_parametres": [
    "iv_parametres",
    "faq_iv_parametres_objectif",
    "faq_iv_parametres_demarrage",
    "faq_iv_parametres_situation"
  ],
  "iv_parametres_donnees": [
    "export_donnees",
    "faq_iv_parametres_donnees_objectif",
    "faq_iv_parametres_donnees_demarrage",
    "faq_iv_parametres_donnees_situation"
  ],
  "iv_planning_lecture": [
    "iv_planning_lecture",
    "faq_iv_planning_lecture_objectif",
    "faq_iv_planning_lecture_demarrage",
    "faq_iv_planning_lecture_situation"
  ],
  "iv_popup_intervention": [
    "iv_popup_actions",
    "iv_start_guard",
    "iv_workflow",
    "iv_refus_motif",
    "faq_iv_popup_intervention_objectif",
    "faq_iv_popup_intervention_demarrage",
    "faq_iv_popup_intervention_situation",
    "faq_iv_popup_intervention_precision"
  ],
  "iv_signalements_emails": [
    "faq_iv_signalements_emails_objectif",
    "faq_iv_signalements_emails_demarrage",
    "faq_iv_signalements_emails_situation"
  ],
  "iv_ui_avatars_medias": [
    "faq_iv_ui_avatars_medias_objectif",
    "faq_iv_ui_avatars_medias_demarrage",
    "faq_iv_ui_avatars_medias_situation",
    "faq_iv_ui_avatars_medias_precision"
  ],
  "iv_ui_banniere_horloge": [
    "faq_iv_ui_banniere_horloge_objectif",
    "faq_iv_ui_banniere_horloge_demarrage",
    "faq_iv_ui_banniere_horloge_situation",
    "faq_iv_ui_banniere_horloge_precision"
  ],
  "iv_ui_boutons_actions": [
    "faq_iv_ui_boutons_actions_objectif",
    "faq_iv_ui_boutons_actions_demarrage",
    "faq_iv_ui_boutons_actions_situation",
    "faq_iv_ui_boutons_actions_precision"
  ],
  "iv_ui_cartes_listes": [
    "faq_iv_ui_cartes_listes_objectif",
    "faq_iv_ui_cartes_listes_demarrage",
    "faq_iv_ui_cartes_listes_situation",
    "faq_iv_ui_cartes_listes_precision"
  ],
  "iv_ui_cartes_statistiques": [
    "faq_iv_ui_cartes_statistiques_objectif",
    "faq_iv_ui_cartes_statistiques_demarrage",
    "faq_iv_ui_cartes_statistiques_situation",
    "faq_iv_ui_cartes_statistiques_precision"
  ],
  "iv_ui_cartes_statuts": [
    "faq_iv_ui_cartes_statuts_objectif",
    "faq_iv_ui_cartes_statuts_demarrage",
    "faq_iv_ui_cartes_statuts_situation",
    "faq_iv_ui_cartes_statuts_precision"
  ],
  "iv_ui_etiquettes_icones": [
    "faq_iv_ui_etiquettes_icones_objectif",
    "faq_iv_ui_etiquettes_icones_demarrage",
    "faq_iv_ui_etiquettes_icones_situation",
    "faq_iv_ui_etiquettes_icones_precision"
  ],
  "iv_ui_fenetres_modales": [
    "faq_iv_ui_fenetres_modales_objectif",
    "faq_iv_ui_fenetres_modales_demarrage",
    "faq_iv_ui_fenetres_modales_situation",
    "faq_iv_ui_fenetres_modales_precision"
  ],
  "iv_ui_filtres_listes": [
    "faq_iv_ui_filtres_listes_objectif",
    "faq_iv_ui_filtres_listes_demarrage",
    "faq_iv_ui_filtres_listes_situation",
    "faq_iv_ui_filtres_listes_precision"
  ],
  "iv_ui_planning_lecture_ui": [
    "faq_iv_ui_planning_lecture_ui_objectif",
    "faq_iv_ui_planning_lecture_ui_demarrage",
    "faq_iv_ui_planning_lecture_ui_situation",
    "faq_iv_ui_planning_lecture_ui_precision"
  ],
  "iv_ui_securite_performance": [
    "faq_iv_ui_securite_performance_objectif",
    "faq_iv_ui_securite_performance_demarrage",
    "faq_iv_ui_securite_performance_situation",
    "faq_iv_ui_securite_performance_precision"
  ],
  "iv_ui_temps_reel": [
    "faq_iv_ui_temps_reel_objectif",
    "faq_iv_ui_temps_reel_demarrage",
    "faq_iv_ui_temps_reel_situation",
    "faq_iv_ui_temps_reel_precision"
  ],
  "login": [
    "login",
    "password",
    "session",
    "guest_connexion_elements",
    "guest_pas_de_compte",
    "faq_login_objectif",
    "faq_login_demarrage",
    "faq_login_situation",
    "faq_login_precision"
  ],
  "sa_dashboard": [
    "sa_dashboard_stats",
    "faq_sa_dashboard_objectif",
    "faq_sa_dashboard_demarrage",
    "faq_sa_dashboard_situation"
  ],
  "sa_formulaire_intervention": [
    "sa_creer_intervention",
    "anti_doublon_intervention",
    "faq_sa_formulaire_intervention_objectif",
    "faq_sa_formulaire_intervention_demarrage",
    "faq_sa_formulaire_intervention_situation",
    "faq_sa_formulaire_intervention_precision"
  ],
  "sa_menu_lateral": [
    "sa_menu_acces",
    "faq_sa_menu_lateral_objectif",
    "faq_sa_menu_lateral_demarrage",
    "faq_sa_menu_lateral_situation",
    "faq_sa_menu_lateral_precision"
  ],
  "sa_messagerie": [
    "sa_messagerie_usage",
    "messagerie_bulle",
    "sa_messaging_mod",
    "faq_sa_messagerie_objectif",
    "faq_sa_messagerie_demarrage",
    "faq_sa_messagerie_situation",
    "faq_sa_messagerie_precision"
  ],
  "sa_notifications_cloche": [
    "sa_cloche",
    "cloche_centre",
    "faq_sa_notifications_cloche_objectif",
    "faq_sa_notifications_cloche_demarrage",
    "faq_sa_notifications_cloche_situation",
    "faq_sa_notifications_cloche_precision"
  ],
  "sa_page_administrateurs": [
    "sa_administrateurs_invitation",
    "faq_sa_page_administrateurs_objectif",
    "faq_sa_page_administrateurs_demarrage",
    "faq_sa_page_administrateurs_situation",
    "faq_sa_page_administrateurs_precision"
  ],
  "sa_page_clients": [
    "sa_clients_sites_equipements",
    "faq_sa_page_clients_objectif",
    "faq_sa_page_clients_demarrage",
    "faq_sa_page_clients_situation",
    "faq_sa_page_clients_precision"
  ],
  "sa_page_intervenants": [
    "sa_intervenants_couleur",
    "faq_sa_page_intervenants_objectif",
    "faq_sa_page_intervenants_demarrage",
    "faq_sa_page_intervenants_situation",
    "faq_sa_page_intervenants_precision"
  ],
  "sa_page_interventions": [
    "sa_liste_interventions_page",
    "sa_intervention_delete",
    "faq_sa_page_interventions_objectif",
    "faq_sa_page_interventions_demarrage",
    "faq_sa_page_interventions_situation",
    "faq_sa_page_interventions_precision"
  ],
  "sa_page_rapports": [
    "sa_rapports_validation_pdf",
    "faq_sa_page_rapports_objectif",
    "faq_sa_page_rapports_demarrage",
    "faq_sa_page_rapports_situation"
  ],
  "sa_parametres": [
    "sa_parametres_systeme",
    "sa_contact_organisation",
    "sa_pages_publiques",
    "sa_sms_organisation",
    "sa_import_export",
    "faq_sa_parametres_objectif",
    "faq_sa_parametres_demarrage",
    "faq_sa_parametres_situation",
    "faq_sa_parametres_precision"
  ],
  "sa_planning_global": [
    "sa_planning_crea",
    "faq_sa_planning_global_objectif",
    "faq_sa_planning_global_demarrage",
    "faq_sa_planning_global_situation",
    "faq_sa_planning_global_precision"
  ],
  "sa_popup_intervention": [
    "sa_popup_actions",
    "sa_fiche_planification",
    "staff_reprogram",
    "faq_sa_popup_intervention_objectif",
    "faq_sa_popup_intervention_demarrage",
    "faq_sa_popup_intervention_situation",
    "faq_sa_popup_intervention_precision"
  ],
  "sa_rapports_activites": [
    "sa_activities",
    "sa_purge_technical",
    "faq_sa_rapports_activites_objectif",
    "faq_sa_rapports_activites_demarrage",
    "faq_sa_rapports_activites_situation"
  ],
  "sa_signalements_emails": [
    "sa_signalement_ticket",
    "faq_sa_signalements_emails_objectif",
    "faq_sa_signalements_emails_demarrage",
    "faq_sa_signalements_emails_situation",
    "faq_sa_signalements_emails_precision"
  ],
  "sa_ui_avatars_medias": [
    "faq_sa_ui_avatars_medias_objectif",
    "faq_sa_ui_avatars_medias_demarrage",
    "faq_sa_ui_avatars_medias_situation",
    "faq_sa_ui_avatars_medias_precision"
  ],
  "sa_ui_banniere_horloge": [
    "faq_sa_ui_banniere_horloge_objectif",
    "faq_sa_ui_banniere_horloge_demarrage",
    "faq_sa_ui_banniere_horloge_situation",
    "faq_sa_ui_banniere_horloge_precision"
  ],
  "sa_ui_boutons_actions": [
    "faq_sa_ui_boutons_actions_objectif",
    "faq_sa_ui_boutons_actions_demarrage",
    "faq_sa_ui_boutons_actions_situation",
    "faq_sa_ui_boutons_actions_precision"
  ],
  "sa_ui_cartes_listes": [
    "faq_sa_ui_cartes_listes_objectif",
    "faq_sa_ui_cartes_listes_demarrage",
    "faq_sa_ui_cartes_listes_situation",
    "faq_sa_ui_cartes_listes_precision"
  ],
  "sa_ui_cartes_statistiques": [
    "sa_dashboard_stats",
    "temps_reel_polling",
    "faq_sa_ui_cartes_statistiques_objectif",
    "faq_sa_ui_cartes_statistiques_demarrage",
    "faq_sa_ui_cartes_statistiques_situation",
    "faq_sa_ui_cartes_statistiques_precision"
  ],
  "sa_ui_cartes_statuts": [
    "faq_sa_ui_cartes_statuts_objectif",
    "faq_sa_ui_cartes_statuts_demarrage",
    "faq_sa_ui_cartes_statuts_situation",
    "faq_sa_ui_cartes_statuts_precision"
  ],
  "sa_ui_couleurs_privileges": [
    "faq_sa_ui_couleurs_privileges_objectif",
    "faq_sa_ui_couleurs_privileges_demarrage",
    "faq_sa_ui_couleurs_privileges_situation",
    "faq_sa_ui_couleurs_privileges_precision"
  ],
  "sa_ui_etiquettes_icones": [
    "faq_sa_ui_etiquettes_icones_objectif",
    "faq_sa_ui_etiquettes_icones_demarrage",
    "faq_sa_ui_etiquettes_icones_situation",
    "faq_sa_ui_etiquettes_icones_precision"
  ],
  "sa_ui_fenetres_modales": [
    "faq_sa_ui_fenetres_modales_objectif",
    "faq_sa_ui_fenetres_modales_demarrage",
    "faq_sa_ui_fenetres_modales_situation",
    "faq_sa_ui_fenetres_modales_precision"
  ],
  "sa_ui_filtres_listes": [
    "sa_filtres_listes",
    "filtres_mobile_grille",
    "faq_sa_ui_filtres_listes_objectif",
    "faq_sa_ui_filtres_listes_demarrage",
    "faq_sa_ui_filtres_listes_situation",
    "faq_sa_ui_filtres_listes_precision"
  ],
  "sa_ui_filtres_planning": [
    "sa_filtres_planning",
    "sa_aucune_intervention",
    "faq_sa_ui_filtres_planning_objectif",
    "faq_sa_ui_filtres_planning_demarrage",
    "faq_sa_ui_filtres_planning_situation",
    "faq_sa_ui_filtres_planning_precision"
  ],
  "sa_ui_journal_activites": [
    "sa_activities",
    "sa_purge_technical",
    "faq_sa_ui_journal_activites_objectif",
    "faq_sa_ui_journal_activites_demarrage",
    "faq_sa_ui_journal_activites_situation",
    "faq_sa_ui_journal_activites_precision"
  ],
  "sa_ui_securite_performance": [
    "faq_sa_ui_securite_performance_objectif",
    "faq_sa_ui_securite_performance_demarrage",
    "faq_sa_ui_securite_performance_situation",
    "faq_sa_ui_securite_performance_precision"
  ],
  "sa_ui_temps_reel": [
    "faq_sa_ui_temps_reel_objectif",
    "faq_sa_ui_temps_reel_demarrage",
    "faq_sa_ui_temps_reel_situation",
    "faq_sa_ui_temps_reel_precision"
  ],
  "support": [
    "contact",
    "signalement",
    "faq_support_objectif",
    "faq_support_demarrage",
    "faq_support_situation"
  ]
};
// @faq-mapping-end

export const GUIDE_SECTIONS_BY_ROLE = {
  common: ['intro', 'login', 'appearance'],
  superadmin: [
    'sa_menu_lateral',
    'sa_ui_banniere_horloge',
    'sa_ui_cartes_statistiques',
    'sa_ui_cartes_statuts',
    'sa_ui_etiquettes_icones',
    'sa_ui_filtres_listes',
    'sa_ui_cartes_listes',
    'sa_ui_fenetres_modales',
    'sa_ui_boutons_actions',
    'sa_ui_avatars_medias',
    'sa_ui_filtres_planning',
    'sa_ui_journal_activites',
    'sa_ui_temps_reel',
    'sa_ui_couleurs_privileges',
    'sa_ui_securite_performance',
    'sa_notifications_cloche',
    'sa_messagerie',
    'sa_signalements_emails',
    'sa_dashboard',
    'sa_planning_global',
    'sa_popup_intervention',
    'sa_formulaire_intervention',
    'sa_page_interventions',
    'sa_page_clients',
    'sa_page_intervenants',
    'sa_page_administrateurs',
    'sa_page_rapports',
    'sa_rapports_activites',
    'sa_parametres',
    'support'
  ],
  admin: [
    'ad_menu_lateral',
    'ad_ui_banniere_horloge',
    'ad_ui_cartes_statistiques',
    'ad_ui_cartes_statuts',
    'ad_ui_etiquettes_icones',
    'ad_ui_filtres_listes',
    'ad_ui_cartes_listes',
    'ad_ui_fenetres_modales',
    'ad_ui_boutons_actions',
    'ad_ui_avatars_medias',
    'ad_ui_filtres_planning',
    'ad_ui_temps_reel',
    'ad_ui_couleurs_privileges',
    'ad_ui_securite_performance',
    'ad_notifications_cloche',
    'ad_messagerie',
    'ad_signalements_emails',
    'ad_dashboard',
    'ad_planning_global',
    'ad_popup_intervention',
    'ad_formulaire_intervention',
    'ad_page_interventions',
    'ad_page_clients',
    'ad_page_intervenants',
    'ad_page_rapports',
    'ad_parametres',
    'ad_parametres_donnees',
    'support'
  ],
  intervenant: [
    'iv_menu_lateral',
    'iv_ui_banniere_horloge',
    'iv_ui_cartes_statistiques',
    'iv_ui_cartes_statuts',
    'iv_ui_etiquettes_icones',
    'iv_ui_filtres_listes',
    'iv_ui_cartes_listes',
    'iv_ui_fenetres_modales',
    'iv_ui_boutons_actions',
    'iv_ui_avatars_medias',
    'iv_ui_planning_lecture_ui',
    'iv_ui_temps_reel',
    'iv_ui_securite_performance',
    'iv_notifications_cloche',
    'iv_messagerie',
    'iv_signalements_emails',
    'iv_dashboard',
    'iv_planning_lecture',
    'iv_popup_intervention',
    'iv_page_interventions',
    'iv_fiche_intervention',
    'iv_page_rapports',
    'iv_formulaire_rapport',
    'iv_disponibilites',
    'iv_parametres',
    'iv_parametres_donnees',
    'support'
  ],
  client: [
    'cl_menu_lateral',
    'cl_ui_banniere_horloge',
    'cl_ui_cartes_statistiques',
    'cl_ui_cartes_statuts',
    'cl_ui_etiquettes_icones',
    'cl_ui_filtres_listes',
    'cl_ui_cartes_listes',
    'cl_ui_fenetres_modales',
    'cl_ui_boutons_actions',
    'cl_ui_avatars_medias',
    'cl_ui_filtres_equipements',
    'cl_ui_temps_reel',
    'cl_ui_securite_performance',
    'cl_notifications_cloche',
    'cl_messagerie',
    'cl_signalements_emails',
    'cl_dashboard',
    'cl_planning_lecture',
    'cl_popup_intervention',
    'cl_page_interventions',
    'cl_fiche_intervention',
    'cl_page_sites',
    'cl_page_equipements',
    'cl_page_rapports',
    'cl_profil',
    'cl_profil_donnees',
    'support'
  ],
  guest: ['intro', 'login', 'appearance', 'guest_ui_connexion', 'guest_ui_elements_visuels', 'guest_public_pages', 'support']
};

/** Clés FAQ par rôle (supportFaq.items.*). */
export const FAQ_KEYS_BY_ROLE = {
  common: [
    'login',
    'password',
    'session',
    'theme_lang',
    'notifications',
    'mobile',
    'contact',
    'signalement',
    'messagerie_bulle',
    'cloche_centre',
    'export_donnees',
    'temps_reel_polling',
    'filtres_mobile_grille'
  ],
  superadmin: [
    'sa_popup_actions',
    'sa_messaging_mod',
    'sa_activities',
    'sa_purge_technical',
    'sa_intervention_delete',
    'anti_doublon_intervention',
    'staff_reprogram',
    'sa_menu_acces',
    'sa_dashboard_stats',
    'sa_filtres_listes',
    'sa_filtres_planning',
    'sa_cloche',
    'sa_messagerie_usage',
    'sa_signalement_ticket',
    'sa_planning_crea',
    'sa_fiche_planification',
    'sa_creer_intervention',
    'sa_liste_interventions_page',
    'sa_clients_sites_equipements',
    'sa_intervenants_couleur',
    'sa_administrateurs_invitation',
    'sa_rapports_validation_pdf',
    'sa_parametres_systeme',
    'sa_contact_organisation',
    'sa_pages_publiques',
    'sa_sms_organisation',
    'sa_import_export',
    'sa_aucune_intervention'
  ],
  admin: [
    'ad_popup_actions',
    'ad_no_delete',
    'ad_intervenant_no_delete',
    'anti_doublon_intervention',
    'staff_reprogram',
    'ad_menu_acces',
    'ad_dashboard',
    'ad_planning',
    'ad_creer_intervention',
    'ad_clients',
    'ad_intervenants',
    'ad_rapports_valid',
    'ad_parametres',
    'ad_pas_activites_reset',
    'ad_pas_moderation',
    'ad_signalement'
  ],
  intervenant: [
    'iv_popup_actions',
    'iv_start_guard',
    'iv_workflow',
    'iv_report',
    'iv_refus_motif',
    'iv_planning_lecture',
    'iv_liste_interventions',
    'iv_rapport_brouillon',
    'iv_rapport_photos',
    'iv_disponibilites',
    'iv_cloche',
    'iv_messagerie',
    'iv_parametres'
  ],
  client: [
    'cl_popup_actions',
    'cl_reprogram_once',
    'cl_reports_pdf',
    'cl_readonly',
    'cl_reprogrammer_conditions',
    'cl_planning_lecture',
    'cl_sites',
    'cl_equipements',
    'cl_interventions_liste',
    'cl_statut_intervention',
    'cl_cloche',
    'cl_messagerie',
    'cl_parametres'
  ],
  guest: [
    'roles',
    'contact',
    'guest_pages_publiques',
    'guest_maintenance',
    'guest_connexion_elements',
    'guest_pas_de_compte'
  ]
};

export function getGuideSectionIds(role) {
  const r = role || 'guest';
  const common = GUIDE_SECTIONS_BY_ROLE.common || [];
  const specific = GUIDE_SECTIONS_BY_ROLE[r] || GUIDE_SECTIONS_BY_ROLE.guest;
  const merged = [...common];
  specific.forEach((id) => {
    if (!merged.includes(id)) merged.push(id);
  });
  return merged;
}

/** Clés FAQ rattachées à une section guide (accordéon 1:1). */
export function getFaqKeysForSection(sectionId) {
  return FAQ_KEYS_BY_SECTION[sectionId] || [];
}

/** Sections guide du rôle avec leurs clés FAQ — même ordre que le guide utilisateur. */
export function getFaqSectionsForRole(role) {
  return getGuideSectionIds(role).map((sectionId) => ({
    sectionId,
    faqKeys: getFaqKeysForSection(sectionId)
  }));
}

/** Liste aplatie (legacy / compat) — toutes les FAQ visibles pour le rôle. */
export function getFaqItemKeys(role) {
  const merged = [];
  getFaqSectionsForRole(role).forEach(({ faqKeys }) => {
    faqKeys.forEach((key) => {
      if (!merged.includes(key)) merged.push(key);
    });
  });
  return merged;
}
